import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import styled, {css} from 'styled-components'

export const StyledMedicalRecordHeader = styled.div(
    ({theme: {spacing, palette, mediaQueries}}) => css`
        display: grid;
        grid-template-columns: 1fr auto;
        gap: ${spacing * 2}px;
        align-items: start;

        padding: ${spacing * 4.5}px ${spacing * 6}px;
        border-bottom: 1px solid ${palette.neutral['200']};

        ${mediaQueries['2xl']} {
            grid-template-columns: 1fr;
            gap: ${spacing * 4}px;

            & > :first-child {
                order: 2;
            }

            & > :last-child {
                order: 1;
                margin-left: auto;
            }
        }
    `
)

export const StyledAddRelationButtonLink = styled(ButtonLink)`
    flex-shrink: 0;
`
